import React, { useState } from "react"

import SoftButton from "@components/common/SoftButton"
import ProductSwiper from "./Carousel/ProductSwiper"
import UseWindowSize from "@components/helpers/UseWindowSize";

const JustInSection = ({justIn, bestSellerCollection}) => {
    
    const { width } = UseWindowSize()
    const justInProducts = (justIn?.products || []).slice(0, 20);
    const bestSellerProducts = (bestSellerCollection?.products || []).slice(0, 20);

    
    const [activeSet, setActiveSet] = useState('just in')

    return (
        <React.Fragment>
            <div className="mt-5 max-w-[1440px] mx-auto" aria-label="just-in-best-sellers">
                <section className="flex gap-x-8 text-[24px]">
                    <SoftButton
                        label={"JUST IN"}
                        onClick={() => setActiveSet("just in")}
                        className={`text-md ${
                            activeSet === "just in" ? "soft-active" : "soft-inactive"
                        }`}
                    />
                    <SoftButton
                        label={"BEST SELLERS"}
                        onClick={() => setActiveSet("best sellers")}
                        className={`text-md ${
                            activeSet === "best sellers" ? "soft-active" : "soft-inactive"
                        }`}
                    />
                </section>

                <section className={`mt-8`}>
                    {width !== null && (
                        <ProductSwiper 
                            products={activeSet === 'just in' ? justInProducts : bestSellerProducts} 
                            spaceBetween={5} 
                            cardStyles={`w-20 lg:w-[262px]`}
                            breakpoints = {{
                                // value of key is min-width property
                                300: {
                                    slidesPerView: 1.8,
                                    spaceBetween: 5,
                                },
                                380: {
                                    slidesPerView: 2,
                                    spaceBetween: 5,
                                },
                                500: {
                                    slidesPerView: 2.5,
                                    spaceBetween: 10,
                                },
                                640: {
                                    slidesPerView: 3,
                                    spaceBetween: 10,
                                },
                                768: {
                                    slidesPerView: 3.5,
                                },
                                769: {
                                    slidesPerView: 2.5,
                                },
                                900: {
                                    slidesPerView: 3,
                                },
                                1024: {
                                    slidesPerView: 3.5,
                                },
                                1280: {
                                    slidesPerView: 4.5,
                                },
                                1440: {
                                    slidesPerView: 5,
                                }
                            }}
                            width={width <=  420 ? '160' : width <=  768 ? '194' : '262'}
                            height={width <=  420 ? '240' : width <=  768 ? '280' : '389'}
                            loop 
                        />
                    )}
                </section>

                {/* <section className={`mt-8 ${activeSet === "best sellers" ? "" : "hidden"}`}>
                    <ProductSwiper 
                        products={bestSellerProducts}
                        spaceBetween={5}
                        breakpoints = {{
                            // value of key is min-width property
                            300: {
                                slidesPerView: 2,
                                spaceBetween: 5,
                            },
                            500: {
                                slidesPerView: 2,
                                spaceBetween: 10,
                            },
                            640: {
                                slidesPerView: 3.5,
                            },
                            900: {
                                slidesPerView: 4,
                            },
                            1024: {
                                slidesPerView: 5,
                            },
                        }}
                        width={width <=  768 ? '160' : '262'}
                        height={width <=  768 ? '240' : '389'}
                        loop
                    />
                </section> */}
            </div>
        </React.Fragment>
    );
}

export default JustInSection;